import templateProjectSituationLegenda from './templates/template-legenda-container';
import templateProjectSituationMap from './templates/template-map-container';
import templateInfoWindowProject from './templates/template-info-window-project';

import { render } from 'lit-html';

import Project from './project';

function ProjectSituationMap(legendaContainer, mapContainer, infowindowContainer, endpoints, options) {
	this.legendaContainer = legendaContainer && legendaContainer.nodeType === 1 ? legendaContainer : null;
	this.mapContainer = mapContainer && mapContainer.nodeType === 1 ? mapContainer : null;
	this.infowindowContainer = infowindowContainer && infowindowContainer.nodeType === 1 ? infowindowContainer : null;

	if (!this.legendaContainer || this.legendaContainer.nodeType !== 1) {
		throw new Error('No legenda container for ProjectSituationMap defined');
	}

	if (!this.mapContainer || this.mapContainer.nodeType !== 1) {
		throw new Error('No map container for ProjectSituationMap defined');
	}

	if (!this.mapContainer.hasAttribute('data-module-id')) {
		throw new Error('No data-module-id attribute found on the container element');
	}

	if (!this.mapContainer.hasAttribute('data-map-width') || !this.mapContainer.hasAttribute('data-map-height')) {
		throw new Error('No width or/and height attribute found on the container element');
	}

	this.state = {
		projectDataLoaded: false,
		projectViewDataLoaded: false,
		activeLegendaStatuses: [],
		isInfowindowOpen: false,
		selectedProject: null,
		loadingProjects: false,
		loadingViews: false,
		error: null
	};

	this.projects = [];

	this.endpoints = {
		projects: '',
		projectViews: ''
	};

	for (var attrname in endpoints) { this.endpoints[attrname] = endpoints[attrname]; }

	//default options
	this.props = {
		showLegenda: true,
		layoutSwitchWidth: 1056,
		mapWidth: this.mapContainer.getAttribute('data-map-width'),
		mapHeight: this.mapContainer.getAttribute('data-map-height'),
		backgroundImageSrc: this.mapContainer.getAttribute('data-background-image-src')
	};

	//voeg input opties samen met default opties
	for (var attrname in options) { this.props[attrname] = props[attrname]; }

	this.rawXmlHttpRequestData = {
		projects: [],
		projectViews: []
	};

	if (this.infowindowContainer) {
		document.addEventListener('click', (event) => {
			this.setState(
				'isInfowindowOpen',
				!this.infowindowContainer.contains(event.target) &&
				!event.target.classList.contains('situation-map-project-shape') &&
				!event.target.classList.contains('situation-map-project-shape-container') ||
				event.target.classList.contains('info-window-project-close') ? false : true
			);
		});
	}

	const reqProjects = new XMLHttpRequest();

	reqProjects.addEventListener('readystatechange', () => {
		if (reqProjects.readyState !== 4) return;
		this.setState('loadingProjects', false);
		if (reqProjects.status !== 200 && reqProjects.status !== 304) {
			const body = JSON.parse(reqProjects.responseText);
			this.setState('error', new Error(body.data[0].message));
			return;
		}

		this.rawXmlHttpRequestData.projects = JSON.parse(reqProjects.responseText);
		this.setState('projectDataLoaded', true);
		this.setupProjects();
	});

	reqProjects.open('GET', this.endpoints.projects);
	reqProjects.setRequestHeader('Content-Type', 'application/json');
	reqProjects.send();

	this.setState('loadingProjects', true);


	const reqProjectViews = new XMLHttpRequest();

	reqProjectViews.addEventListener('readystatechange', () => {
		if (reqProjectViews.readyState !== 4) return;
		this.setState('loadingViews', false);
		if (reqProjectViews.status !== 200 && reqProjectViews.status !== 304) {
			const body = JSON.parse(reqProjects.responseText);
			this.setState('error', new Error(body.data[0].message));
			return;
		}

		this.rawXmlHttpRequestData.projectViews = JSON.parse(reqProjectViews.responseText);
		this.setState('projectViewDataLoaded', true);
		this.setupProjects();
	});

	// TODO: append to existing unknown query params could be solved easier when IE11 supports drops with: https://developer.mozilla.org/en-US/docs/Web/API/URL
	reqProjectViews.open('GET', this.endpoints.projectViews + '&module-id=' + this.mapContainer.getAttribute('data-module-id'));
	reqProjectViews.setRequestHeader('Content-Type', 'application/json');
	reqProjectViews.send();

	this.setState('loadingViews', true);
}

ProjectSituationMap.prototype.render = function() {
	render(templateProjectSituationMap(this), this.mapContainer);
	render(templateProjectSituationLegenda(this), this.legendaContainer);
	if (this.infowindowContainer) {
		render(templateInfoWindowProject(this), this.infowindowContainer);
	}
};

ProjectSituationMap.prototype.setState = function(prop, value) {
	if (typeof this.state[prop] !== 'undefined') {
		this.state[prop] = value;
	}
	this.render();
};

ProjectSituationMap.prototype.isProjectsLoaded = function() {
	return this.state.projectDataLoaded && this.state.projectViewDataLoaded;
};

ProjectSituationMap.prototype.setupProjects = function() {
	if (!this.isProjectsLoaded()) {
		return;
	}

	this.rawXmlHttpRequestData.projectViews.forEach(projectView => {
		const matched = this.rawXmlHttpRequestData.projects.filter(projectData => projectData.id == projectView.id);

		if (matched.length === 1) {
			this.projects.push(new Project(matched[0], projectView));
		}
	});

	this.setState('activeLegendaStatuses', this.getStatuses());
	this.render();
};

ProjectSituationMap.prototype.getStatuses = function() {
	return this.projects.map(project => ({
		value: project.getStatus(),
		label: project.getStatusLabel()
	})).filter((status, index, array) => {
		const foundIndex = array.findIndex(statusForIndex => (
			status.value == statusForIndex.value
		));
		return foundIndex === index;
	});
};

ProjectSituationMap.prototype.getStatusByValue = function(value) {
	const statuses = this.getStatuses().filter(status => status.value == value);
	return statuses.length === 1 ? statuses[0] : null;
};

ProjectSituationMap.prototype.getStatusLabels = function() {
	return this.projects.map(project => project.getStatusLabel()).filter((statusLabel, index, array) => array.indexOf(statusLabel) === index);
};

ProjectSituationMap.prototype.updateLegendaStatus = function(status) {
	const newStatuses = this.state.activeLegendaStatuses.filter(activeStatus => activeStatus.value != status);
	const activeStatuses = newStatuses.length === this.state.activeLegendaStatuses.length ?
		this.state.activeLegendaStatuses.concat([this.getStatusByValue(status)]) : newStatuses;
	this.setState('activeLegendaStatuses', activeStatuses);
};

ProjectSituationMap.prototype.selectProject = function(project) {
	if (!this.infowindowContainer) {
		window.location = project.getUrl();
		return;
	}

	this.setState('selectedProject', project);
	this.setState('isInfowindowOpen', true);
};

export default ProjectSituationMap;